import src from "IMAGE";
export default { src, width: 1563, height: 1563, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
